export const CHANGE_PLAYER = 'PLAYER:CHANGE';
export const SET_MEDIA = 'PLAYER:SET_MEDIA';
export const PLAYER_CREATED = 'PLAYER:CREATED';
export const PLAYER_EVENT_MEDIACHANGE = 'PLAYER:EVENT:MEDIACHANGE';
export const PLAYER_EVENT_ENDED = 'PLAYER:EVENT:ENDED';
export const PLAYER_EVENT_MUTECHANGE = 'PLAYER:EVENT:MUTECHANGE';
export const PLAYER_EVENT_LOADEDDATA = 'PLAYER:EVENT:LOADEDDATA';
export const PLAYER_EVENT_PLAYING = 'PLAYER:EVENT:PLAYING';
export const PLAYER_EVENT_PAUSED = 'PLAYER:EVENT:PAUSED';
export const PLAYER_EVENT_TIMEUPDATE = 'PLAYER:EVENT:TIMEUPDATE';
export const CREATE_PLAYER = 'PLAYER:CREATE';
export const DESTROY_PLAYER = 'PLAYER:DESTROY';